var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDev)?_c('div',{staticStyle:{"background-color":"red","text-align":"center"}},[_c('strong',[_vm._v("DEV Server "),(_vm.git)?_c('span',[_vm._v(_vm._s(_vm.git.branch)+"#"+_vm._s(_vm.git.commit))]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0547fcbb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DevBanner.vue
// module id = null
// module chunks = 